<div class="container">
    <h1 class="customer-register" *ngIf=" !DataRecieved">Demo Registration</h1>
    <div class="form-container register-form-container" *ngIf=" !DataRecieved">
        <!-- <div class="register-form"> -->
        <!-- <p class="title">{{'registrationDemoForm.ll1'|cxTranslate}}</p>
            <p class="title mt-4">{{'registrationDemoForm.ll2'|cxTranslate}}</p>
            <p class="title mt-2">{{'registrationDemoForm.ll3'|cxTranslate}}</p>
            <p class="title mt-4">{{'registrationDemoForm.l4'|cxTranslate}}</p>
            <p class="title mt-2">{{'registrationDemoForm.l5'|cxTranslate}}<a href="mailto:DemoTeam.ELY@bendix.com">
                    {{'registrationDemoForm.demo_team'|cxTranslate}}</a></p>
            <p class="title mt-4">{{'registrationDemoForm.l6'|cxTranslate}}</p>
            <p class="title mt-2">{{'registrationDemoForm.l7'|cxTranslate}}</p>
            <p class="title mt-2">{{'registrationDemoForm.l8'|cxTranslate}}</p> -->


        <!-- <p class="title">{{'registrationDemoForm.l2'|cxTranslate}}<a href="mailto:DemoTeam.ELY@bendix.com">
                    {{'registrationDemoForm.demo_team'|cxTranslate}}</a></p>
            <p class="title mt-3">{{'registrationDemoForm.l3'|cxTranslate}}</p> -->
        <!-- </div> -->
        <div class="form-field-control register-form-control">
            <form *ngIf="demoRegistrationForm" [formGroup]="demoRegistrationForm" (ngSubmit)="onSubmit()" novalidate
                autocomplete="off">
                <div class="d-flex flex-sm-row flex-column">
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 demo-code">
                        <!-- Private Demo Access Code -->
                        <label for="PrivateDemo" class="control-label">Demo Access Code
                            <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info"
                                (click)="openPopupDemoCode()" />
                        </label>
                        <input type="text" formControlName="PrivateDemo" class="form-control" name="PrivateDemo">
                    </div>
                </div>
                <div class="row">
                    <div class="col register-col">
                        <p class="req-info-text">{{'common.register_site_company'|cxTranslate}}</p>
                        <div class="d-flex flex-sm-row flex-column">
                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6"> <!-- Email Address -->
                                <label for="email" class="control-label">Email Address*</label>
                                <input type="email" (blur)="checkExistingEmailAddress()" class="form-control"
                                    formControlName="emailAddress"
                                    [ngClass]="{ 'is-valid':(demoRegistrationForm?.get('emailAddress')?.dirty || submitted) && !demoRegistrationForm?.get('emailAddress')?.errors,
                                     'is-invalid': (demoRegistrationForm?.get('emailAddress').dirty || submitted) && demoRegistrationForm?.get('emailAddress')?.errors }" />
                                <div class="invalid-feedback">
                                    <span class="text-danger-show"
                                        *ngIf=" demoRegistrationForm?.get('emailAddress')?.errors && demoRegistrationForm?.get('emailAddress')?.errors['required']">{{'common.register_email_invalid'|cxTranslate}}</span>
                                    <span class="text-danger-show"
                                        *ngIf=" demoRegistrationForm?.get('emailAddress')?.errors && demoRegistrationForm?.get('emailAddress')?.errors['emailAddress']">{{'common.register_email_invalid'|cxTranslate}}</span>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <!-- Confirm Email Address -->
                                <label for="email" class="control-label">
                                    {{'registrationDemoForm.confirmEmailAddresslabel'|cxTranslate}}
                                </label>
                                <input type="email" class="form-control" formControlName="confirmemailAddress"
                                    [ngClass]="{
                                                'is-invalid':
                                                demoRegistrationForm.get('confirmemailAddress')?.invalid &&
                                                (demoRegistrationForm.get('confirmemailAddress')?.touched ||
                                                demoRegistrationForm.get('confirmemailAddress')?.dirty),

                                                'is-valid':
                                                demoRegistrationForm.get('confirmemailAddress')?.valid &&
                                                (demoRegistrationForm.get('confirmemailAddress')?.touched ||
                                                demoRegistrationForm.get('confirmemailAddress')?.dirty)
                                            }" />
                                <div class="invalid-feedback">

                                    <span class="text-danger-show" *ngIf="
                                  demoRegistrationForm.get('confirmemailAddress')?.errors?.['required']
                                ">
                                        {{ 'common.register_email_invalid' | cxTranslate }}
                                    </span>

                                    <span class="text-danger-show" *ngIf="
                                  demoRegistrationForm.get('confirmemailAddress')?.errors?.['emailMismatch']
                                ">
                                        {{ 'registrationDemoForm.confirmEmailAddressError' | cxTranslate }}
                                    </span>

                                </div>

                            </div>
                        </div>
                        <div class="d-flex flex-sm-row flex-column">
                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6"> <!--First Name-->
                                <label for="firstName"
                                    class="control-label">{{'common.register_firstName'|cxTranslate}}</label>
                                <input type="text" formControlName="firstName" class="form-control"
                                    [ngClass]="{ 'is-valid': (demoRegistrationForm?.get('firstName').dirty || submitted) && !demoRegistrationForm?.get('firstName')?.errors,
                                    'is-invalid': (demoRegistrationForm?.get('firstName').dirty || submitted) && demoRegistrationForm?.get('firstName')?.errors }" name="firstName">
                                <div class="invalid-feedback">
                                    <span class="text-danger-show"
                                        *ngIf=" demoRegistrationForm?.get('firstName')?.errors && demoRegistrationForm?.get('firstName')?.errors['required']">{{'common.register_firstName_invalid'|cxTranslate}}</span>
                                </div>
                            </div>
                            <!--Last Name-->
                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="lastName"
                                    class="control-label">{{'common.register_lastName'|cxTranslate}}</label>
                                <input type="text" formControlName="lastName" class="form-control" name="lastName"
                                    [ngClass]="{ 'is-valid': (demoRegistrationForm?.get('lastName').dirty || submitted) && !demoRegistrationForm?.get('lastName')?.errors,
                                    'is-invalid': (demoRegistrationForm?.get('lastName').dirty || submitted) && demoRegistrationForm?.get('lastName')?.errors }">
                                <div class="invalid-feedback">
                                    <span class="text-danger-show"
                                        *ngIf=" demoRegistrationForm?.get('lastName')?.errors && demoRegistrationForm?.get('lastName')?.errors['required']">{{'common.register_lastName_invalid'|cxTranslate}}</span>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-sm-row flex-column">
                            <!--Company Name-->
                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="companyName"
                                    class="control-label">{{'common.register_company_name'|cxTranslate}}</label>
                                <input type="text" formControlName="companyName" class="form-control" name="companyName"
                                    [ngClass]="{ 'is-valid': (demoRegistrationForm?.get('companyName')?.dirty || submitted) && !demoRegistrationForm?.get('companyName')?.errors, 'is-invalid': (demoRegistrationForm?.get('companyName')?.dirty || submitted) && demoRegistrationForm?.get('companyName')?.errors }">
                                <div class="invalid-feedback">
                                    <span class="text-danger-show"
                                        *ngIf=" demoRegistrationForm?.get('companyName')?.errors && demoRegistrationForm?.get('companyName')?.errors['required']">{{'common.register_company_name_invalid'|cxTranslate}}</span>
                                </div>
                            </div>
                            <!--Title-->
                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="title" class="control-label">Job Title*</label>
                                <input type="text" formControlName="titleCode" class="form-control" name="title"
                                    [ngClass]="{ 'is-valid': (demoRegistrationForm?.get('titleCode').dirty || submitted) && !demoRegistrationForm?.get('titleCode')?.errors,
                                    'is-invalid': (demoRegistrationForm?.get('titleCode').dirty || submitted) && demoRegistrationForm?.get('titleCode')?.errors }"
                                    name="titleCode">
                                <div class="invalid-feedback">
                                    <span class="text-danger-show"
                                        *ngIf=" demoRegistrationForm?.get('titleCode')?.errors && demoRegistrationForm?.get('titleCode')?.errors['required']">{{'common.register_jobTitle_invalid'|cxTranslate}}</span>
                                </div>
                            </div>

                        </div>


                        <div class="d-flex flex-sm-row flex-column">
                            <!--Address1-->
                            <!-- <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="address1"
                                    class="control-label">{{'common.register_company_address_street'|cxTranslate}}</label>
                                <input type="text" formControlName="companyStreet" class="form-control"
                                    name="companyStreet"
                                    [ngClass]="{ 'is-valid': (demoRegistrationForm?.get('companyStreet')?.dirty || submitted) && !demoRegistrationForm?.get('address1')?.errors, 'is-invalid': (demoRegistrationForm?.get('companyStreet')?.dirty || submitted) && demoRegistrationForm?.get('companyStreet')?.errors }">
                                <div class="invalid-feedback">
                                    <span class="text-danger-show"
                                        *ngIf=" demoRegistrationForm?.get('companyStreet')?.errors && demoRegistrationForm?.get('companyStreet')?.errors['required']">{{'common.register_company_address_street_invalid'|cxTranslate}}</span>
                                </div>
                            </div> -->
                            <!--Address2-->
                            <!-- <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="address2"
                                    class="control-label">{{'common.register_company_address_two'|cxTranslate}}</label>
                                <input type="text" formControlName="companyAddressTwo" class="form-control"
                                    name="address2">
                            </div> -->
                        </div>


                        <div class="d-flex flex-sm-row flex-column">
                            <!--City-->
                            <!-- <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="city"
                                    class="control-label">{{'common.register_company_address_city'|cxTranslate}}</label>
                                <input type="text" formControlName="companyCity" class="form-control" name="city"
                                    [ngClass]="{ 'is-valid': (demoRegistrationForm?.get('companyCity')?.dirty || submitted) && !demoRegistrationForm?.get('companyCity')?.errors, 'is-invalid': (demoRegistrationForm?.get('companyCity')?.dirty || submitted) && demoRegistrationForm?.get('companyCity')?.errors }">
                                <div class="invalid-feedback">
                                    <span class="text-danger-show"
                                        *ngIf=" demoRegistrationForm?.get('companyCity')?.errors && demoRegistrationForm?.get('companyCity')?.errors['required']">{{'common.register_company_address_city_invalid'|cxTranslate}}</span>
                                </div>
                            </div> -->
                            <!--Zip-->
                            <!-- <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="zip"
                                    class="control-label">{{'common.register_company_address_zip'|cxTranslate}}</label>
                                <input type="text" maxlength="15" formControlName="companyZip" class="form-control"
                                    name="zip"
                                    [ngClass]="{ 'is-valid': (demoRegistrationForm?.get('companyZip')?.dirty || submitted) && !demoRegistrationForm?.get('companyZip')?.errors, 'is-invalid': (demoRegistrationForm?.get('companyZip')?.dirty || submitted) && demoRegistrationForm?.get('companyZip')?.errors }">
                                <div class="invalid-feedback">
                                    <span class="text-danger-show"
                                        *ngIf=" demoRegistrationForm?.get('companyZip')?.errors && demoRegistrationForm?.get('companyZip')?.errors['required']">{{'common.register_company_address_zip_invalid'|cxTranslate}}</span>
                                </div>
                            </div> -->
                        </div>


                        <div class="d-flex flex-sm-row flex-column">
                            <!--Country-->
                            <!-- <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <ng-container *ngIf="(pageFieldData$|async) as pageFieldData">
                                    <label for="country"
                                        class="control-label">{{'common.register_company_countryCode'|cxTranslate}}</label>
                                    <div class="select-box">
                                        <select name="country" class="form-control" formControlName="companyCountryCode"
                                            (change)="onCountryChange($event)"
                                            [ngClass]="{ 'is-valid': (demoRegistrationForm?.get('companyCountryCode')?.dirty || submitted) && !demoRegistrationForm?.get('companyCountryCode')?.errors, 'is-invalid': (demoRegistrationForm?.get('companyCountryCode').dirty || submitted) && demoRegistrationForm?.get('companyCountryCode')?.errors }">
                                            <option value="null" disabled selected>
                                                {{'common.form_register_empty'|cxTranslate}}</option>
                                            <option *ngFor="let item of pageFieldData['countriesWSList']"
                                                [value]="item.isocode">{{item.name}}</option>
                                        </select>
                                        <div class="invalid-feedback">
                                            <span class="text-danger-show"
                                                *ngIf=" demoRegistrationForm?.get('companyCountryCode')?.errors && demoRegistrationForm?.get('companyCountryCode')?.errors['required']">{{'common.register_company_countryCode_invalid'|cxTranslate}}</span>
                                        </div>
                                    </div>
                                </ng-container>

                            </div> -->
                            <!--State-->
                            <!-- <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="state"
                                    class="control-label">{{'common.register_company_companyStateCode'|cxTranslate}}</label>
                                <div class="select-box">
                                    <select name="state" class="form-control" formControlName="companyStateCode"
                                        [ngClass]="{ 'is-valid': (demoRegistrationForm?.get('companyStateCode').dirty || submitted) && !demoRegistrationForm?.get('companyStateCode')?.errors, 'is-invalid': (demoRegistrationForm?.get('companyStateCode').dirty || submitted) && demoRegistrationForm?.get('companyStateCode')?.errors }">
                                        <option value="null" disabled selected>
                                            {{'common.register_state_placeholder'|cxTranslate}}</option>
                                        <option *ngFor="let item of stateList?.regionsWSList" [value]="item.isocode">
                                            {{item.name}}</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <span class="text-danger-show"
                                            *ngIf=" demoRegistrationForm?.get('companyStateCode')?.errors && demoRegistrationForm?.get('companyStateCode')?.errors['required']">
                                            <span>{{'common.register_company_companyStateCode_invalid'|cxTranslate}}</span>
                                        </span>
                                    </div>
                                </div>

                            </div> -->
                        </div>
                        <div class="d-flex flex-sm-row flex-colomn">
                            <!-- <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="phone"
                                    class="control-label">{{'common.register_company_phoneNumber'|cxTranslate}}</label>
                                <input type="text" maxlength="15" formControlName="companyPhoneNumber"
                                    class="form-control" name="phone">
                            </div> -->
                        </div>

                        <!-- Company Role -->
                        <div class="d-flex flex-sm-row flex-column"
                            *ngIf="!demoRegistrationForm?.get('PrivateDemo')?.value">
                            <ng-container *ngIf=demoPageData>
                                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 industryRole"
                                    formArrayName="industryRoleCodes">
                                    <label for="email"
                                        class="control-label">{{'common.register_site_companyrole'|cxTranslate}}</label>
                                    <div class="form-check"
                                        [ngClass]="{ 'is-invalid': demoRegistrationForm?.get('industryRoleCodes').value.length && submitted}"
                                        *ngFor="let roleList of demoPageData.industryRolesWSList; let i=index">
                                        <input class="form-check-input" [id]="" [disabled]="formSubmitted"
                                            [formControlName]="i.toString()"
                                            (change)="onOtherCompanyInformationsChnage(roleList.code,'')" type="radio"
                                            [value]="roleList.code" [id]="'test'+i"
                                            [checked]="industryRoleCodes.value.includes(roleList.code)">
                                        <label class="form-check-label " for="distributor">
                                            {{roleList.name}}
                                        </label>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6" *ngIf="showVehicleTypes">
                                <label for="multiSelect" class="control-label">Select All Vehicle Type(s) that
                                    Apply* <img class="img-w-20" src="/icons/question_dark_kb.svg"
                                        (click)="openVehicalPopup()"></label>
                                <label class="d-flex" *ngFor="let option of options;let i= index">
                                    <input type="checkbox" [formControl]="getDemoFormControl(i)"
                                        class="form-control multiSelectInfo"
                                        (change)="onMultiSlectOptionChange(option.code,$event.target,i,false)">
                                    <label class="ml-5 font-20">{{option.name}}</label>
                                </label>
                                <input *ngIf="isOtherSelected" type="text" formControlName="otherOptions"
                                    [disabled]="formSubmitted" placeholder="Please Specify" class="form-control">
                                <div class="invalid-feedback d-block" *ngIf="showVechicalError">
                                    <span class="text-danger-show">Please select VehicalType</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12">
                            <re-captcha id="recaptcha" formControlName="recaptcha" (resolved)="checkCaptcha($event)"
                                formControlName="recaptcha" name="recaptcha" required
                                [class.is-invalid]="submitted && !captchaResolved">
                            </re-captcha>
                            <div class="invalid-feedback" *ngIf="submitted!; captchaResolved">
                                {{'common.general_required'|cxTranslate}}.
                            </div>
                        </div>

                        <!-- submit button -->
                        <div class="form-group col-xs-12 col-sm-6 col-md-4 submit-btn">
                            <button type="submit" class="btn btn-block create-btn">
                                <i
                                    [attr.class]="!demoRegistrationForm?.valid ? 'bi-hourglass-split' : 'bi-check2-square'"></i>
                                {{'common.select_demo'|cxTranslate}}
                                <img src="/icons/link-dark-grey.svg" class="register-icon-right default-icon" alt="">
                            </button>
                        </div>

                    </div>
                </div>
            </form>
        </div>

    </div>

    <div class="row mt-5" *ngIf="DataRecieved">
        <div class="col-xs-12 col-sm-12 tech-training-description-table-outer">
            <table class="table table-bordered demotable">
                <thead>
                    <tr class="hidden-xs hidden-sm">
                        <!-- <th scope="col" style="width:2%"></th> -->
                        <th scope="col" style="width:25%">
                            {{'registrationDemoForm.date_and_times'|cxTranslate}}
                        </th>
                        <th scope="col" style="width:25%">
                            {{'registrationDemoForm.demo'|cxTranslate}}
                        </th>
                        <th scope="col" style="width:25%">
                            {{'registrationDemoForm.Locations'|cxTranslate}}
                        </th>
                        <th scope="col" style="width:25%">
                            {{'registrationDemoForm.Wavier'|cxTranslate}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="demoDataTraining?.length; else noData">
                        <tr *ngFor="let listItem of demoDataTraining;let i = index"
                            [class.selected]="selectedItemIndex === i">
                            <!-- <td class="radio-button">
                                <input type="radio" name="itemRadio" [checked]="selectedItemIndex === i"
                                    (change)="onSelect(i)" />
                            </td> -->
                            <td><span class="mycompany-registration-lable d-lg-none">
                                    {{'registrationDemoForm.date_and_times'|cxTranslate}}
                                </span>
                                <span class="mycompnay-registration-value">
                                    <b>{{ getConvertedDate( listItem?.demoStartDate)}}</b>
                                    <br>
                                    <ng-container *ngFor="let schedule of listItem?.demoSchedule">
                                        <span>
                                            {{ schedule?.startTime }} <ng-container *ngIf="schedule?.endTime"> - {{
                                                schedule?.endTime }}</ng-container>
                                        </span>
                                    </ng-container>
                                </span>
                            </td>
                            <td>
                                <span class="mycompany-registration-lable d-lg-none">
                                    {{'registrationDemoForm.demo'|cxTranslate}}
                                </span>
                                <span class="mycompnay-registration-value">
                                    <b> {{ listItem?.demoName }}</b>
                                    <br>
                                    {{ listItem?.demoDescription }}
                                </span>
                            </td>
                            <td>
                                <span class="mycompany-registration-lable d-lg-none">
                                    {{'registrationDemoForm.Locations'|cxTranslate}}
                                </span>
                                <span class="mycompnay-registration-value">
                                    <ng-container *ngIf=" listItem?.address?.companyName?.length">
                                        {{ listItem?.address?.companyName }}<br>
                                    </ng-container>
                                    <ng-container *ngIf="listItem?.address?.line1?.length">
                                        {{ listItem?.address?.line1 }} <br>
                                    </ng-container>
                                    <ng-container *ngIf="listItem?.address?.line2?.length">
                                        {{ listItem?.address?.line2 }} <br>
                                    </ng-container>
                                    <ng-container *ngIf="listItem?.address?.town?.length">
                                        {{listItem?.address?.town }},
                                    </ng-container>
                                    <ng-container *ngIf="listItem?.address?.region?.name?.length">
                                        {{listItem?.address?.region?.isocodeShort }}
                                    </ng-container>
                                    <ng-container *ngIf="listItem?.address?.postalCode?.length">
                                        {{listItem?.address?.postalCode }}<br>
                                    </ng-container>
                                    <a href="https://www.google.com/maps/search/?api=1&amp;query={{ listItem?.address?.formattedAddress }}"
                                        class="google-link" target="_blank">
                                        (Google Maps)
                                    </a> <br>
                                </span>
                            </td>
                            <td class="v-align-middle">
                                <span class="mycompany-registration-lable d-lg-none">
                                    {{'registrationDemoForm.Wavier'|cxTranslate}}
                                </span>
                                <!-- Terms And Conditions -->

                                <div class="form-check dataProtection mycompnay-registration-value">

                                    <label class="m-0">


                                        @if(listItem.isCustomerRegisteredDemo){
                                        <div class="waiver-accepted">
                                            <span class="icon">✔</span>
                                            <span class="text">
                                                {{ 'registrationDemoForm.Wavier_accepted_sentence' | cxTranslate }}
                                            </span>
                                        </div>
                                        }
                                        @else{
                                        <ng-container *ngIf="!demoWavierAcceptedOrNot[i]">
                                            <!-- {{ 'registrationDemoForm.Wavier_sentence' | cxTranslate }} -->
                                            <button class="btn btn-block create-btn"
                                                (click)="!demoWavierAcceptedOrNot[i] && openTermsAndConditionsDialog(i,listItem.demoCode)"
                                                [class.disabled]="demoWavierAcceptedOrNot[i]"
                                                [attr.aria-disabled]="demoWavierAcceptedOrNot[i]?'true':null"
                                                [attr.tabindex]="demoWavierAcceptedOrNot[i]?'-1':null">
                                                {{'registrationDemoForm.Wavier_sentence'|cxTranslate}}
                                                <img src="/icons/link-dark-grey.svg"
                                                    class="register-icon-right default-icon" alt="">
                                            </button>
                                        </ng-container>
                                        }
                                    </label>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-template #noData>
                        <tr class="training-details-no-results">
                            <td colspan="4">
                                <strong>
                                    {{ 'common.text_no_result_found' | cxTranslate }}
                                </strong>
                            </td>
                        </tr>
                    </ng-template>

                </tbody>
            </table>
            <div class="demo-action-buttons">
                <button class="btn btn-block create-btn-secondary" (click)="goBackToPrefilled()">
                    <img src="/icons/link_left_white.svg" class="register-icon-right default-icon ml-0 mr-10" alt="">
                    Back
                </button>
                <button class="btn btn-block create-btn m-0" (click)="goToNewRegistration()">
                    New Registration <img src="/icons/link-dark-grey.svg" class="register-icon-right default-icon"
                        alt="">
                </button>
                <button class="btn btn-block create-btn m-0" (click)="goToLandingPage()">
                    Learn More <img src="/icons/link-dark-grey.svg" class="register-icon-right default-icon" alt="">
                </button>
            </div>
        </div>
    </div>

</div>
<!-- Popup for contactName -->
<div class="popup-backdrop" *ngIf="popupOpendemoCode"></div>

<div class="popup-modal" *ngIf="popupOpendemoCode">
    <div class="popup-header">
        <button class="close-btn" aria-label="close dialog" (click)="closePopupCompanyName()">
            <img src="/icons/close-light-grey.svg" alt="" />
        </button>
    </div>


    <div class="popup-body">
        <p class="popup-head-text mb-4">{{'common.demo_access_code'|cxTranslate}}</p>
        <p class="mt-3">{{'registrationDemoForm.popupMsgDemoCode'|cxTranslate}}</p>
    </div>
</div>